export const BASE_URL = 'https://dummyjson.com';

export const ENDPOINTS = {
  CATEGORIES: '/products/category-list',
  ALL_PRODUCTS: '/products?limit=12&skip=',
  CATEGORY_PRODUCTS: '/products/category/',
  ONE_PRODUCT: '/products/',
  QUERY_PRODUCT: '/products/search?q=',
  PER_PAGE: 'limit=12&skip=',
};

export const KEY = {
  WISH_KEY: 'wishlist',
  CART_KEY: 'cart',

  // USER_VALUE_SESSION_STORAGE_KEY: 'user-value-key',
};

export const PAGE_SIZE = 12;
